import _filter from "lodash/filter";

export function filterPackages(packagesObj, filter) {
  filter = filter.toLowerCase();
  const filterType = typeof filter;
  const newObj = {};

  for (const key of Object.keys(packagesObj)) {
    if (filterType === "string") {
      if (
        key.toLowerCase().indexOf(filter) !== -1 ||
        packagesObj[key].some((x) => includesStr(x, filter))
      ) {
        newObj[key] = packagesObj[key];
      }
    } else if (filterType === "object") {
      newObj[key] = _filter(packagesObj[key], filter);
    }
  }

  return newObj;
}

function includesStr(packageObj, str) {
  return (
    packageObj &&
    packageObj.chocoPackage &&
    ((packageObj.chocoPackage.Id &&
      packageObj.chocoPackage.Id.toLowerCase().indexOf(str) !== -1) ||
      (packageObj.chocoPackage.Title &&
        packageObj.chocoPackage.Title.toLowerCase().indexOf(str) !== -1) ||
      (packageObj.chocoPackage.Tags &&
        packageObj.chocoPackage.Tags.toLowerCase().indexOf(str) !== -1) ||
      (packageObj.chocoPackage.Description &&
        packageObj.chocoPackage.Description.toLowerCase().indexOf(str) !== -1))
  );
}
